import { InlineStack, Tooltip } from '@shopify/polaris';
import React from 'react';
import { TextFieldHoverI } from '../Interfaces/interfaces';

export const TextFieldHover = (props: TextFieldHoverI) => {
    let { active, content, textColor, value, icon } = props;
    let style: any = { borderBottom: '2px dotted gray', color: textColor ?? 'black', cursor: 'help' };
    return <>
        <InlineStack gap="100">
            <Tooltip active={active} content={content} >
                <span style={style}> {value} </span>
            </Tooltip>
        </InlineStack>
    </>;
}